<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Event Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="loading">
    <h3 class="text-muted">Loading...</h3>
  </div>

  <div class="modal-body" *ngIf="!loading && scheduledEvent">

    <p>
      <b>
        <ng-container *ngIf="scheduledEvent.is_private">Private Event - </ng-container>
        {{ scheduledEvent.name }}
        <ng-container *ngIf="scheduledEvent.event_part_count > 1">
          (Part {{ scheduledEvent.event_part_number }} of {{ scheduledEvent.event_part_count }})
        </ng-container>
      </b>
      <br>
      <b>
        {{ dateStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }},
        {{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }} -
        {{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}
      </b>
    </p>

    <p>
      <ng-container *ngIf="scheduledEvent.roster_name">
        Roster: <b>{{ scheduledEvent.roster_name }}</b>
        <br>
      </ng-container>
      Location:
      <ng-container *ngIf="scheduledEvent.gym_area_name">
        <b>{{ scheduledEvent.location_name }}, {{ scheduledEvent.gym_area_name }}</b>
      </ng-container>
      <ng-container *ngIf="!scheduledEvent.gym_area_name">
        <b>{{ scheduledEvent.location_name }}</b>
      </ng-container>
      <br>
      Time Zone:
      <b>
        {{ getTimeZoneDisplayName(scheduledEvent.time_zone) }} time
      </b>
    </p>

    <p *ngIf="!scheduledEvent.is_private">
      Reservations: <b>{{ scheduledEvent.reservation_count }}/{{ scheduledEvent.capacity }}</b> <br>
      <span [class.text-danger]="scheduledEvent.remaining_capacity <= 0">
        Remaining Capacity: <b>{{ scheduledEvent.remaining_capacity }}</b>
      </span>
      <ng-container *ngIf="scheduledEvent.capacity > (scheduledEvent.remaining_capacity + scheduledEvent.reservation_count)">
        <br>
        <span class="text-muted">Remaining capacity is reduced either due to other events sharing this event's facility area, or due to this event's booking limit having been reached.</span>
      </ng-container>
    </p>

    <p *ngIf="scheduledEvent.is_private">
      Number of Participants: <b>{{ scheduledEvent.reservation_count }}</b>
    </p>

    <label class="mb-0">
      Instructors:
    </label>
    <ul>
      <li *ngIf="scheduledEvent.instructors.length === 0" class="text-muted">None</li>
      <li *ngFor="let instructor of scheduledEvent.instructors">
        <b>{{ instructor.first_name }} {{ instructor.last_name }}</b>
      </li>
    </ul>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loading">
      Loading...
    </button>
    <a class="btn btn-primary"
       [routerLink]="getScheduledEventRouterPath(scheduledEvent)"
       (click)="activeModal.close()"
       *ngIf="!loading && scheduledEvent">
      Go To Event
    </a>
  </div>

</ng-container>
